import { c as _c } from "react/compiler-runtime";
import { Close } from '@radix-ui/react-dialog';
import CloseIcon from '@/components/shared/Icon/CloseIcon';
import css from './style.module.scss';
const DialogClose = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Close className={css.dialogClose}><CloseIcon size={14} className={css.closeIcon} variation="green" /></Close>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default DialogClose;